import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { Atribuicao } from 'src/app/models/rh/atribuicao.model';
import { AuthService } from '../vos/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AtribuicoesService {

    constructor(
        private http: HttpClient,
        private authService: AuthService) { }
    //Ordemservico-Prestadores
    getAtribuicao(): Observable<Atribuicao[]> {
        return this.http.get<Atribuicao[]>(`${URL_GLOBAL}/ordemservicoPrestadores`);
    }

    save(data: any): Observable<any> {
        return this.http.post<any>(`${URL_GLOBAL}/ordemservicoPrestadores`, data);
    }

    find(id: any): Observable<any> {
        return this.http.get(`${`${URL_GLOBAL}/ordemservicoPrestadores`}/${id}`);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put<any>(`${`${URL_GLOBAL}/ordemservicoPrestadores`}/${id}`, data);
    }

    destroy(id: any): Observable<any> {
        return this.http.delete<any>(`${`${URL_GLOBAL}/ordemservicoPrestadores`}/${id}`);
    }
    PegarTodosOsRegistrosPorIdDaEmpresa(id: any): Observable<any[]> {
        return this.http.get<any[]>(`${`${URL_GLOBAL}/web/prestadores/buscaPrestadorComServicosPrestadosNaEmpresa`}/${id}`, { headers: this.authService.userToken() }); 
    }
    profissionaisatribuidosaopaciente(id): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/ordemservicoPrestadores/ordemservico/${id}`);
    }
    pacientesatribuidosaoprofissional(id): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/ordemservicoPrestadores/pacienteporprofissional/${id}`, { headers: this.authService.userToken() }); 
    }
    //Ordemservico-Servico
    getOrdemservicoServico(): Observable<Atribuicao[]> {
        return this.http.get<Atribuicao[]>(`${URL_GLOBAL}/ordemservicoServicos`);
    }

    saveOrdemservicoServico(data: any): Observable<any> {
        return this.http.post<any>(`${URL_GLOBAL}/ordemservicoServicos`, data);
    }

    findOrdemservicoServico(id: any): Observable<any> {
        return this.http.get(`${`${URL_GLOBAL}/ordemservicoServicos`}/${id}`);
    }

    updateOrdemservicoServico(id: any, data: any): Observable<any> {
        return this.http.put<any>(`${`${URL_GLOBAL}/ordemservicoServicos`}/${id}`, data);
    }

    destroyOrdemservicoServico(id: any): Observable<any> {
        return this.http.delete<any>(`${`${URL_GLOBAL}/ordemservicoServicos`}/${id}`);
    }
    OrdemservicoServicoPorIdDaEmpresa(param: any): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/ordemservicoServicos`, { params: new HttpParams().append("commands", JSON.stringify(param)) });
    }

    // END POINT

    // SALVA ATRIBUIÇÃO COM CONTRACT
    saveNew(data: any): Observable<any> { 
        return this.http.post<any>(`${URL_GLOBAL}/newordemservicoPrestadores`, data, { headers: this.authService.userToken() });
    }
    // BUSCA PACIENTES ATRIBUIDOS AO PRESTADOR
    pacientesatribuidosaoprofissionalNew(id): Observable<any> {   
        return this.http.get<any>(`${URL_GLOBAL}/newordemservicoPrestadores/pacienteporprofissional/${id}`, { headers: this.authService.userToken() }); 
    }
    // BUSCA PRESTADORES ATRIBUIDOS AO PACIENTE
    profissionaisatribuidosaopacienteNew(id): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/newordemservicoPrestadores/contract/${id}`, { headers: this.authService.userToken() });
    }
}
